export const AUDITED_FINANCIALS_DOC_TYPE_ID = "audited-financials";
export const MANAGEMENT_FINANCIALS_DOC_TYPE_ID = "management-financials";
export const FINANCIAL_STATEMENT_DOC_TYPE_ID = "financial-statement";

const REQUIRED_PER_TYPE = 2;

type UploadedDoc = {
  document_type?: string;
  document_type_name?: string;
};

const isAuditedDoc = (doc: UploadedDoc) =>
  doc.document_type === AUDITED_FINANCIALS_DOC_TYPE_ID ||
  doc.document_type_name?.toLowerCase().includes("audited");

const isManagementDoc = (doc: UploadedDoc) =>
  doc.document_type === MANAGEMENT_FINANCIALS_DOC_TYPE_ID ||
  doc.document_type_name?.toLowerCase().includes("management");

const isLegacyFinancialStatement = (doc: UploadedDoc) =>
  doc.document_type === FINANCIAL_STATEMENT_DOC_TYPE_ID ||
  doc.document_type_name?.toLowerCase().includes("financial statement");

/** Buyer RF presales: 2 audited + 2 management financials before leaving CL step. */
export const areBuyerFinancialStatementsComplete = (
  uploadedDocs?: UploadedDoc[] | null,
): boolean => {
  const allUploaded = uploadedDocs ?? [];
  const auditedCount = allUploaded.filter(
    (doc) => isAuditedDoc(doc) || isLegacyFinancialStatement(doc),
  ).length;
  const managementCount = allUploaded.filter((doc) =>
    isManagementDoc(doc),
  ).length;
  return (
    auditedCount >= REQUIRED_PER_TYPE && managementCount >= REQUIRED_PER_TYPE
  );
};
